import { baseService, GLOBAL_TAG_TYPES } from '@repo/services';
import { transformGraphqlResponse } from '@repo/utils';
import { type AutomationListResponse, getAutomationList } from 'automations/queries';
import { getExecutionsPerLead, type GetExecutionsPerLeadResponse } from 'automations/queries/getExecutionsPerLead';

export interface AutomationListProps {
  filterOptions?: {
    triggerType?: string;
    status?: string;
    updatedBy?: string;
    updatedAt?: string;
    name?: string;
  };
  limit?: number;
  offset?: number;
  sortOptions?: {
    sortField: string;
    sortOrder: 'asc' | 'desc';
  };
}

const automationListService = baseService.injectEndpoints({
  endpoints: (build) => ({
    getAutomationList: build.query<AutomationListResponse, AutomationListProps>({
      query: (params = {}) => ({
        method: 'POST',
        url: '/graphql',
        body: { query: getAutomationList, variables: params },
      }),
      providesTags: [GLOBAL_TAG_TYPES.automationList],
      transformResponse: transformGraphqlResponse,
    }),
    getExecutionsPerLeadList: build.query<GetExecutionsPerLeadResponse, {
      leadUuid: string;
      limit?: number;
      offset?: number;
    }>({
      query: ({
        leadUuid,
        limit = 10,
        offset = 0,
      }) => ({
        method: 'POST',
        url: '/graphql',
        body: { query: getExecutionsPerLead, variables: { leadUuid, limit, offset } },
      }),
      transformResponse: transformGraphqlResponse,
    }),
  }),
});

export const {
  useGetAutomationListQuery,
  useGetExecutionsPerLeadListQuery,
} = automationListService;
